<template>
    <v-menu
      attach
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      :disabled="disbaled"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          outlined dense
          v-model="inputValue"
          :label="label"
          :disabled="disbaled"
          hide-details="auto"
          prepend-icon="mdi-calendar"
          @blur="onBlur"
          @keydown.enter.prevent="onEnter"
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker locale="es-SV" :value="parseDate(value)" @change="onChange" no-title scrollable @input="menu = false"  :disabled="disbaled">

      </v-date-picker>
    </v-menu>
</template>

<script>
export default {
  name: "DatePicker2",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10)
        .replaceAll("-", "/")
    }, 
    disbaled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      menu: false,
      inputValue: this.value || '',
    };
  },
  watch: {
    value(newValue) {
      this.inputValue = newValue || '';
    }
  },
  methods: {
    onChange(event) {
      const newDate = this.formatDate(event)
      this.inputValue = newDate;
      this.$emit('change', newDate)
      this.$emit('update', newDate)
    },
    onEnter() {
      this.commitTypedDate();
    },
    onBlur() {
      this.commitTypedDate();
    },
    commitTypedDate() {
      if (!this.inputValue) {
        this.$emit('change', '');
        this.$emit('update', '');
        return;
      }

      if (!this.isValidDate(this.inputValue)) {
        this.inputValue = this.value || '';
        return;
      }

      const normalized = this.formatTypedDate(this.inputValue);
      this.inputValue = normalized;
      this.$emit('change', normalized);
      this.$emit('update', normalized);
    },
    isValidDate(dateString) {
      if (!dateString) return false;
      const [day, month, year] = String(dateString).split("/");
      if (!day || !month || !year) return false;

      const dayNum = parseInt(day, 10);
      const monthNum = parseInt(month, 10);
      const yearNum = parseInt(year, 10);

      if (isNaN(dayNum) || isNaN(monthNum) || isNaN(yearNum)) return false;
      if (monthNum < 1 || monthNum > 12) return false;
      if (dayNum < 1 || dayNum > 31) return false;

      const date = new Date(yearNum, monthNum - 1, dayNum);
      return (
        date.getFullYear() === yearNum &&
        date.getMonth() === monthNum - 1 &&
        date.getDate() === dayNum
      );
    },
    formatTypedDate(dateString) {
      const [day, month, year] = String(dateString).split("/");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    formatDate(date) {
      if (!date) return null;
      
      const [year, month, day] = date.split("-");
      return `${day.padStart(2, "0")}/${month.padStart(2, "0")}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
